import React from "react";
import { Box, Typography } from "@mui/material";
import InfoTooltip from "../overlays/InfoTooltip";

interface OutputFieldProps {
  label: string;
  value: string | React.ReactNode;
  tooltip?: string; // Optionaler Tooltip-Text bei Hover
  sx?: object;
}

/**
 * Einfaches Ausgabefeld ohne Umrandung mit Label im Status-Stil
 * Optional mit Tooltip bei Hover (zeigt Help-Cursor)
 */
const OutputField: React.FC<OutputFieldProps> = ({
  label,
  value,
  tooltip,
  sx = {},
}) => {
  const content = (
    <Box sx={sx}>
      <Typography
        variant="body2"
        color="textSecondary"
        sx={{ mb: 1, fontWeight: 400, fontSize: "0.875rem" }}
      >
        {label}
      </Typography>
      {typeof value === "string" ? (
        <Typography
          variant="body1"
          sx={{
            color: "text.primary",
            fontWeight: 400,
          }}
        >
          {value}
        </Typography>
      ) : (
        value
      )}
    </Box>
  );

  // Wenn Tooltip vorhanden, mit InfoTooltip wrappen
  if (tooltip) {
    return (
      <InfoTooltip title={tooltip} placement="top">
        {content}
      </InfoTooltip>
    );
  }

  return content;
};

export default OutputField;
